import type { ChartDataItem } from "../types";

export const formatLineChartData = (
  data: ChartDataItem[],
  seriesKeys: string[],
  indexBy: string,
): Array<{ id: string; data: Array<{ x: string | number; y: number }> }> =>
  seriesKeys.map(seriesKey => ({
    id: seriesKey,
    data: data.map(item => ({
      x: item[indexBy],
      y: Number(item[seriesKey] || 0),
    })),
  }));

export const computeYMinMax = (
  series: Array<{ data: Array<{ y: number }> }>,
): [number, number] => {
  let minV = Infinity;
  let maxV = -Infinity;
  for (const s of series) {
    for (const p of s.data) {
      const v = Number(p.y);
      if (!Number.isFinite(v)) continue;
      if (v < minV) minV = v;
      if (v > maxV) maxV = v;
    }
  }
  return minV === Infinity || maxV === -Infinity ? [0, 1] : [minV, maxV];
};
